var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "report" },
    [
      _c("content-wrapper", {
        scopedSlots: _vm._u([
          {
            key: "filters",
            fn: function () {
              return [
                _c("FinalRibbon", {
                  attrs: { fleetList: _vm.fleetList },
                  on: {
                    "selection-details": _vm.updateComponents,
                    download: _vm.download,
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _vm.isDataSelected && !_vm.selectedAssets.length
                  ? _c("div", { staticClass: "no-assets pl-5" }, [
                      _vm._v(_vm._s(_vm.$t("noDataAvailable"))),
                    ])
                  : _vm._e(),
                _vm.isDataSelected && _vm.selectedAssets.length
                  ? _c(
                      "div",
                      { staticClass: "pl-2 pr-2", attrs: { id: "reportdiv" } },
                      _vm._l(_vm.selectedAssets, function (asset) {
                        return _c("ReportGrid", {
                          key: asset.id,
                          attrs: {
                            id: _vm.idPrefix + asset.id.toString(),
                            serialNumber: asset.finalRunSno,
                            asset: { ...asset },
                            isNewUi: false,
                          },
                        })
                      }),
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm.isDownloading
        ? _c("div", { staticClass: "popup" }, [_c("eas-loader")], 1)
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }